import { useLocalization } from '@/data/Localization';
import { Typography, Link, Stack, Box } from '@mui/material';
import {
	footerCallCenterPhoneTextMobileSX,
	footerCallCenterReceiveOffersTitleSX,
} from '@/components/content/Footer/styles/callCenter';
import { footerTypographyUnfocusedSX } from '@/components/content/Footer/styles/general';
import { titleSX } from '@/components/blocks/GroupPageLink/styles';
import { PhoneIcon } from '@/components/content/Footer/parts/PhoneIcon';
import { SubscriptionNewsLetter } from '@/components/content/Footer/parts/SubscriptionNewsLetter';
import { DpLogosMobile } from '@/components/content/Footer/parts/DpLogos';
import React from 'react';
import { Linkable } from '@/components/blocks/Linkable';

interface CallCenterMobileProps {
	breakToMobileFooter: boolean;
}

export const CallCenterMobile: React.FC<CallCenterMobileProps> = ({ breakToMobileFooter }) => {
	const footerNLS = useLocalization('Footer');

	return (
		<Stack
			sx={{
				display: 'flex',
				flexDirection: breakToMobileFooter ? 'column' : 'row',
				justifyContent: 'space-between',
				alignItems: breakToMobileFooter ? 'normal' : 'flex-start',
			}}
		>
			<Stack sx={{ marginBottom: '14px' }}>
				<Typography sx={titleSX}>{footerNLS.CallCenter.WeCanHelp.t()}</Typography>
				<Link href="tel:6699155300">
					<Typography variant="body2" component="div" sx={footerCallCenterPhoneTextMobileSX}>
						<PhoneIcon width="16" height="16" viewBox="0 0 12 12" />
						{footerNLS.CallCenter.PhoneNumber.t()}
					</Typography>
				</Link>
				<Linkable href="/contactanos" sx={footerTypographyUnfocusedSX}>
					{'Consulta nuestros horarios'}
				</Linkable>
				{!breakToMobileFooter ? <DpLogosMobile breakToMobileFooter={breakToMobileFooter} /> : null}
			</Stack>
			<Stack>
				<Typography
					variant="body2"
					textTransform="uppercase"
					component="div"
					sx={footerCallCenterReceiveOffersTitleSX}
				>
					{footerNLS.CallCenter.ReceiveOffers.t()}
				</Typography>
				<SubscriptionNewsLetter
					placeholder={footerNLS.CallCenter.EmailLabel.t()}
					buttonLabel={footerNLS.CallCenter.Subscribe.t()}
				/>
				<Box marginTop="11px">
					{breakToMobileFooter ? <DpLogosMobile breakToMobileFooter={breakToMobileFooter} /> : null}
				</Box>
			</Stack>
		</Stack>
	);
};
